module.exports = __webpack_public_path__ + "img/logo.7709fdfd.svg";